/**
 * Models an API healthcheck response
 */

import Brace from "backbone.brace";
import Radio from "backbone.radio";
import environment from "../../common/environment";
import DatasourceCollection from "../../collections/healthcheck/datasources";
import { types as alertTypes } from "../../config/alerts";
import unfetch from "unfetch";
import { checkFetchStatus } from "../../utils";

const channel = Radio.channel("global");

const Healthcheck = Brace.Model.extend({
  urlRoot: environment.getEndpoint("healthcheck"),

  namedAttributes: {
    message: String,
    applicationStatus: String,
    dataSources: DatasourceCollection,
    score: Number,
    status: String,
    icon: String,
    label: String,
    lastUpdated: Date,
  },

  defaults: {
    message: null,
    applicationStatus: null,
    dataSources: null,
    score: null,
    status: null,
    icon: null,
    label: null,
    lastUpdated: null,
  },

  initialize() {
    this.listenTo(this, "change", this.updateScore);
  },

  updateScore(model, options) {
    if (_.isEmpty(options)) {
      return false;
    }

    const ds = model.getDataSources();
    const total = ds.length;
    const pass = ds.where({ status: "PASSED" }).length;
    const skipped = ds.where({ status: "SKIPPED" }).length;

    // assume failure
    let score = 0;
    let status = "danger";
    let label = "Failed";

    // calculate score
    try {
      score = ((pass + skipped) / total) * 100;
      if (!_.isNumber(score)) {
        score = 0;
      }
    } catch (err) {
      // console.error(err.stack)
    }

    if (score === 100) {
      status = "success";
      label = "Healthy";
    } else if (score > 0 && score < 100) {
      status = "warning";
      label = "Unhealthy";
    }

    this.set({
      score,
      status,
      icon: alertTypes[status],
      label,
      lastUpdated: new Date(),
    });
  },

  sync(method, model, options) {
    const deferred = new jQuery.Deferred();

    if (method === "read") {
      const { token, shardId } = channel.request("auth:credentials");
      const fetchOptions = {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "shard-id": shardId,
        },
      };

      unfetch(model.urlRoot, fetchOptions)
        .then(checkFetchStatus)
        .then((data) => data.json())
        .then((json) => {
          // update model and trigger change event
          model.set(json).trigger("change", model, json, options);
          // resolve promise
          deferred.resolve(json);
        })
        .catch(() => {});
    } else {
      deferred.reject(new Error(`Method ${method} is not implemented...`));
    }

    return deferred;
  },
});

export { Healthcheck as default };
